import React from 'react';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';
import { Link } from '@interlayer/js/components/common/Link/Link';

import { componentService } from '@core/js/services/component.service';

import { TContactItemProps } from './types';

import style from '@interlayer/js/app/components/common/ContactsBlock/ContactsBlock.scss';

export const ContactItem: React.FC<TContactItemProps> = ({ link, fonticontype, linkicon, children }) => (
    <Link
        href={link}
        className={style.link}
    >
        <>
            {fonticontype
                ? (
                    <SvgIcon
                        type={fonticontype}
                        className={style.icon}
                    />
                )
                : (
                    <img
                        src={linkicon}
                        alt={linkicon}
                        className={style.icon}
                        data-testid="ContactItem_imgIcon"
                    />
                )
            }

            <span data-testid="ContactItem_children" className={style.label}>{children}</span>
        </>
    </Link>
);

componentService.registerWebContentComponents({ ContactItem });
